<div class="canvas-container" dir="ltr">
  <canvas *ngIf="!width" id="{{ chartId }}" [attr.height]="height"></canvas>
  <canvas
    *ngIf="width"
    id="{{ chartId }}"
    [attr.height]="height"
    [attr.width]="width"
  ></canvas>
</div>

<div
  id="cycle_duration_tooltip"
  *ngIf="id.startsWith('cycle_duration')"
  class="tooltip"
>
  <div *ngFor="let p of tooltipDataPoints">
    <div class="title">{{ p.dataset.label }}</div>
    <span class="value blue">
      {{ p.dataset.txtValues[p.dataIndex] | number }}
      ({{ p.raw.y | percent }})
    </span>
  </div>
</div>
